import { render, staticRenderFns } from "./DosyadakiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=22e22a63"
import script from "./DosyadakiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyadakiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports